export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHUlEQVR42mNgYGD4TyFm+P+fTDxqwKgB1DWAEgwAoQtKxK7e6i8AAAAASUVORK5CYII="